/* eslint-disable react/jsx-no-useless-fragment */
// pls fix me
import { memo } from 'react';
import Drawer from '@mui/material/Drawer';
import { PropertiesPanelContent } from './PropertiesPanelContent';

export const RIGHT_PANEL_WIDTH = 320;

function PropertiesPanelComponent() {
  return (
    <>
      <Drawer
        variant='permanent'
        anchor='right'
        open
        sx={{
          width: RIGHT_PANEL_WIDTH,
          '& .MuiDrawer-paper': {
            width: RIGHT_PANEL_WIDTH,
            mt: '48px',
            height: 'calc(100% - 48px)',
            overflow: 'hidden',
          },
        }}
      >
        <PropertiesPanelContent />
      </Drawer>
    </>
  );
}

export const PropertiesPanel = memo(PropertiesPanelComponent);
